import * as types from "./types";


export const fetchingRentableCircles = () => ({
  type: types.FETCHING_RENTABLE_CIRCLES,
  loading: true,
});

export const fetchedRentableCircles = (circles) => ({
  type: types.FETCHED_RENTABLE_CIRCLES,
  circles: circles,
  loading: false,
});

export const errorFetchingRentableCircles = (error) => ({
  type: types.ERROR_FETCHING_RENTABLE_CIRCLES,
  error: error,
  loading: false
});

